export default import.meta.ROLLDOWN_FILE_URL_AyoHyCJ6oM$w3VtZBasLKg